import React from 'react';
import { Route, IndexRoute, IndexRedirect } from 'react-router';
import { injectIntl, FormattedMessage } from 'react-intl';
import RecallsList from './containers/recalls-list';
import RecallDetails from './containers/recall-details';

import AdminImports from './containers/admin/imports';
import ImportDocumentation from './views/static/import-documentation';

import Dashboard from './containers/dashboard/loadable';

import Header from './containers/header';
import NavbarTop from './views/navbar-top';
import Disclaimer from './views/disclaimer';
import Footer from './views/footer';
import AboutPortal from './views/static/about-portal';
import Benefits from './views/static/benefits';
import ProjectPartners from './views/static/project-partners';
import Endorsements from './views/static/endorsements';
import AboutUs from './views/static/about-us';
import Links from './views/static/links';
import JurisdictionsDisclaimers from './views/static/jurisdictions-disclaimers';
import RssFeedPage from './views/static/rss-feed';
import PageContainer from './views/page-container';
import messages from './utils/messages';

const AdminApp = ({ children }) => {
  document.title = "Global Recalls - Admin";
  return (
    <div className="container">
      <Header/>
      {children}
      <br/>
      <br/>
      <Footer/>
    </div>
  )
};

const DashboardApp = ({ children }) => {
  document.title = "Global Recalls - Dashboard";
  return (
    <div className="container">
      <Header/>
      <NavbarTop/>
      {children}
      <Disclaimer/>
      <Footer/>
    </div>
  )
};

const App = ({ children, intl }) => {
  document.title = intl.formatMessage(messages.documentTitle);
  return (
    <div>
      <Header/>
      <NavbarTop/>
      {children}
      <Disclaimer/>
      <Footer/>
    </div>
  );
};

export default (
  <Route path="/" name="Home" getDisplayName={() => <FormattedMessage id="navbar.home"/>}>
    <Route path="" component={injectIntl(App)}>
      <IndexRoute
        component={RecallsList}
        name="Recalls list"
        routeKey="recalls-list"
      />
      <Route path="" component={PageContainer}>
        <Route
          path="recalls/:uri"
          component={RecallDetails}
          name="Details"
          routeKey="recall-details"
          hasCloseButton
          getDisplayName={() => <FormattedMessage id="details.recalls.details.title"/>}
        />
        <Route
          path="about-portal"
          component={AboutPortal}
          name="About the portal"
          getDisplayName={() => <FormattedMessage id="about.portal"/>}
        />
        <Route
          path="benefits"
          component={Benefits}
          name="Benefits"
          getDisplayName={() => <FormattedMessage id="benefits"/>}
        />
        <Route
          path="project-partners"
          component={ProjectPartners}
          name="Project partners"
          getDisplayName={() => <FormattedMessage id="project.partners"/>}
        />
        <Route
          path="endorsements"
          component={Endorsements}
          name="Endorsements"
          getDisplayName={() => <FormattedMessage id="endorsements"/>}
        />
        <Route
          path="about-us"
          component={AboutUs}
          name="About us"
          getDisplayName={() => <FormattedMessage id="about.us"/>}
        />
        <Route
          path="links"
          component={Links}
          name="Links"
          getDisplayName={() => <FormattedMessage id="jurisdictions.websites"/>}
        />
        <Route
          path="jurisdictions-disclaimers"
          component={JurisdictionsDisclaimers}
          name="JurisdictionsDisclaimers"
          getDisplayName={() => <FormattedMessage id="jurisdictions.disclaimers"/>}
        />
        <Route
          path="rss-feed"
          component={RssFeedPage}
          name="RssFeed"
          getDisplayName={() => <FormattedMessage id="rss.feed"/>}
        />
      </Route>
    </Route>
    <Route path="dashboard" component={DashboardApp}>
      <IndexRoute
        component={Dashboard}
        name="Dashboard"
        routeKey="dashboard"
      />
    </Route>
    <Route path="admin" component={AdminApp}>
      <IndexRoute
        component={AdminImports}
        name="Imports"
        routeKey="admin-imports"
      />
      <Route
        path="import-documentation"
        component={ImportDocumentation}
      />
    </Route>
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js